module.exports = __webpack_public_path__ + "img/BeastlyMaze1.e20c48a0.png";